import "./navigation--viewport";
export default (function () {
  var contactBox = document.getElementById("contact-state");
  if (contactBox) {
    window.addEventListener("navigationChange", function () {
      contactBox.checked = false;
    });
  }
})();
